import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState, useContext } from 'react';
import { BallTriangle } from 'react-loader-spinner';
import { Context } from '../..';
import EventsService from '../../services/EventsService';
import { ModalPopover } from './modal/modal-popover';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import {EventSettingsModalForSU} from "./modal/EventSettingsModalForSU";

const Event: FC<any> = observer(({ event, setDelEventId, setDelEventModal }) => {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [eventSettingsModalForSU, setEventSettingsModalForSU] = useState<boolean>(false);

    const date = event['create_date'].split('T');
    const formattedDate = date[0].split('-');

    // setEventDate(`${formattedDate[2]}.${formattedDate[1]}.${formattedDate[0]}`);
    return (
        <div className={"col-md-2" + (window.innerWidth > 480 ? ' h-100' : '')}>
            <div style={{ cursor: "pointer" }} onClick={() => {
                navigate(`/event/${event['id']}`)
                
            }}>
                <hr />
                <div className="mb-3 img_wrap">
                    <img src={event['image1']} className="w-100" alt="" />
                </div>
                <div className="mb-3">
                    <div className="text-end">{formattedDate[2]}.{formattedDate[1]}.{formattedDate[0]}</div>
                </div>
                <div className="mb-3">
                    <h6>{event['header'].substring(0, 100) + (event['header'].length < 100 ? '' : '...')}</h6>
                </div>
            </div>
            {store.user.is_superuser ?
                <div className="row">
                    <div className="col cursor-pointer" onClick={() => {
                        setEventSettingsModalForSU(true);
                    }}>
                        <i className='icon admin ms-3' />
                        <Trans>Edit</Trans>
                    </div>
                    <div className="col cursor-pointer" onClick={() => {
                        setDelEventId(event['id']);
                        setDelEventModal(true);
                    }}>
                        <i className='icon trash ms-3' />
                        <Trans>Delete</Trans>
                    </div>
                </div>
                : null}
            <EventSettingsModalForSU data={event} toggle={eventSettingsModalForSU} setToggle={setEventSettingsModalForSU} />
        </div>
    )
});


const ListPaginate = () => {
    const { store } = useContext(Context);
    const onPageChange = ({ selected }: {selected: number}) => {
        store.setPage(++selected);
    }
    return store.pages > 1 ? (
        <nav aria-label="Page navigation">
            <ReactPaginate
                pageCount={store.pages}
                forcePage={store.page - 1}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={onPageChange}
                containerClassName={'pagination justify-content-end'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                activeClassName={'active'}
                previousLabel={'<'}
                previousClassName={'d-none'}
                previousLinkClassName={'page-link'}
                nextLabel={'>'}
                nextClassName={'d-none'}
                nextLinkClassName={'page-link'}
                breakLabel={'...'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
            />
        </nav>
    ) : null;
};



const Events: FC = () => {
    const { store } = useContext(Context);
    const [events, setEvents] = useState<[]>([]);
    const [loader, setLoader] = useState<boolean>(false);
    const [delEventId, setDelEventId] = useState<number>(-1);
    const [delEventModal, setDelEventModal] = useState<boolean>(false);

    const getEvents = async () => {
        const events = await EventsService.getEvents(store.page);
        setEvents(events.data.results);
        store.setPages(Math.ceil(events.data.count/6))
        setLoader(false);
    };

    useEffect(() => {
        setLoader(true);
        getEvents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.page]);

    const getItems = () => events.sort((a, b) => b['id'] - a['id']).map((event, i) => {
        return <Event key={i} {...{ event, setDelEventId, setDelEventModal }} />
    })

    const deleteEvent = async () => {
        await EventsService.removeEvent(delEventId);
        getEvents();
        setDelEventModal(false);
        setDelEventId(-1);
    };


    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div>
            <div className="row m-3">
                <ListPaginate />
                <div className="row pb-5">
                    {getItems()}
                </div>
                {/* <ListPaginate /> */}
            </div>
            <ModalPopover
                toggle={delEventModal}
                setToggle={setDelEventModal}
                title={store.lang === 'ba' ? 'Ваҡиғаны алып ташлау' : store.lang === 'ru' ? 'Удаление события' : 'Deleting an event'}
                modalContent={<Trans>Do you want to delete an event?</Trans>}
                clickedButtonOne={() => deleteEvent()}
                clickedButtonTwo={() => { setDelEventModal(false); setDelEventId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    )
};
export default observer(Events);